import state from "./state";
import * as getters from './getter';
import * as mutations from './mutation';
import * as actions from './action';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
